import { fontSize as webFontSize } from "../../../BuilderUI/constants/DefaultStyleAttributes/fontSize";

export const fontSize = {
  ...webFontSize,
  defaultValue: "16px",
  sliderProps: {
    ...webFontSize.sliderProps,
    /** @TODO This does not need to be a select because we only have px */
    units: ["px"],
    defaultUnit: "px",
  },
} as const;
